var _g, _g2, _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMessages = function SvgMessages(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_105_599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2695 46.4544C18.2695 39.1673 18.2695 35.5237 20.2971 32.8459C22.3247 30.1682 25.8317 29.1801 32.8458 27.2039L43.225 24.2796C45.9196 23.5204 47.2669 23.1408 48.6487 23.1408C50.0306 23.1408 51.3779 23.5204 54.0725 24.2796L64.4517 27.2039C71.4657 29.1801 74.9727 30.1682 77.0003 32.8459C79.0279 35.5237 79.0279 39.1673 79.0279 46.4544V58.3864C79.0279 67.8145 79.0279 72.5285 76.099 75.4574C73.1701 78.3864 68.456 78.3864 59.0279 78.3864H38.2695C28.8414 78.3864 24.1274 78.3864 21.1985 75.4574C18.2695 72.5285 18.2695 67.8145 18.2695 58.3864L18.2695 46.4544Z",
    fill: "url(#paint0_linear_105_599)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_105_599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1194 14.1923C25.5241 14.1923 22.6096 18.1583 22.6096 23.0507V42.4376C35.3588 51.9749 42.0692 61.2204 48.6489 61.2678C55.3679 61.3161 61.9505 51.9662 74.6882 42.4376V23.0507C74.6882 18.1583 71.7736 14.1923 68.1783 14.1923H29.1194Z",
    fill: "#B9DDFF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9155 23.0507C22.9155 20.6629 23.6272 18.5133 24.7628 16.968C25.8985 15.4226 27.4423 14.4982 29.1194 14.4982H68.1783C69.8554 14.4982 71.3992 15.4226 72.535 16.968C73.6706 18.5133 74.3822 20.6629 74.3822 23.0507V42.2845C69.8383 45.6937 66.0712 49.0824 62.8133 52.013C61.5403 53.1582 60.345 54.2334 59.2115 55.2125C57.1757 56.9711 55.3427 58.4174 53.6077 59.4211C51.8742 60.4238 50.2573 60.9734 48.6511 60.9618C47.0789 60.9505 45.479 60.3898 43.7514 59.3825C42.0228 58.3745 40.1859 56.9313 38.142 55.1791C36.997 54.1975 35.788 53.1197 34.5 51.9713C31.2312 49.057 27.4526 45.6882 22.9155 42.2845V23.0507Z",
    stroke: "url(#paint1_linear_105_599)",
    strokeWidth: 0.611895
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.4238,
    y: 27.2759,
    width: 3.79009,
    height: 25.5498,
    rx: 1.89505,
    transform: "rotate(90 61.4238 27.2759)",
    fill: "url(#paint2_linear_105_599)",
    fillOpacity: 0.9,
    stroke: "url(#paint3_linear_105_599)",
    strokeWidth: 0.489516
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4238,
    y: 40.1146,
    width: 3.79009,
    height: 25.5498,
    rx: 1.89505,
    transform: "rotate(90 61.4238 40.1146)",
    fill: "url(#paint4_linear_105_599)",
    fillOpacity: 0.9,
    stroke: "url(#paint5_linear_105_599)",
    strokeWidth: 0.489516
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0511 37.0933C78.0908 37.191 78.1293 37.2892 78.1667 37.388C78.636 38.6277 78.8497 40.0057 78.947 41.8897L50.0176 65.0683C49.2204 65.7071 48.0782 65.7071 47.2809 65.0683L18.3513 41.8895C18.4486 40.0056 18.6623 38.6277 19.1316 37.388C19.169 37.2892 19.2075 37.1909 19.2472 37.0931L48.6493 60.6505L78.0511 37.0933Z",
    fill: "url(#paint6_linear_105_599)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_105_599",
    x: 4.96426,
    y: 9.83548,
    width: 87.3689,
    height: 81.8561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6.65264
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_105_599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_105_599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_105_599",
    x: 9.30429,
    y: 0.886991,
    width: 78.6892,
    height: 73.6862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6.65264
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_105_599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_105_599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_599",
    x1: 35.796,
    y1: 34.9216,
    x2: 81.4844,
    y2: 52.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#159DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_105_599",
    x1: 50.8188,
    y1: 7.13094,
    x2: 49.9331,
    y2: 51.8351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996024,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_105_599",
    x1: 64.052,
    y1: 57.1755,
    x2: 64.052,
    y2: 22.2216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_105_599",
    x1: 53.1596,
    y1: 61.8791,
    x2: 72.0878,
    y2: 22.1656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_105_599",
    x1: 60.1494,
    y1: 66.1305,
    x2: 64.0862,
    y2: 34.6422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_105_599",
    x1: 55.6723,
    y1: 67.5327,
    x2: 70.9514,
    y2: 40.5709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_105_599",
    x1: 35.8308,
    y1: 43.3175,
    x2: 69.6732,
    y2: 68.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EA6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0604165,
    stopColor: "#5AA5DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#159DFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Messages.77923bc15539f8dcb4e9efa870817f90.svg";